export const MAX_MOCKUP_REQUEST_COUNT = 8;
export const MINIMUM_SWAG_ITEMS = 150;

export const SWAG_CATALOG_URL = `${
  process.env.NEXT_PUBLIC_SWAGMAGIC_TEST_URL || "https://www.swagmagic.com"
}/swag-catalog/us/full/all-products`;

export const SEND_CURATED_BOX_URL = "https://www.swagmagic.com/send-curated-box";
export const ONDEMAND_SWAG_URL = "https://www.swagmagic.com/on-demand-swag";

export const CATALOG_KIND_BRANDED_KEY = "branded";
export const CATALOG_KIND_LOCKER_KEY = "locker";
export const CATALOG_KIND_WISHLIST_KEY = "wishlist";
export const CATALOG_KIND_PURCHASED_KEY = "purchased";
export const CATALOG_KIND_FREE_MOCKUPS_KEY = "free_mockups";
export const CATALOG_KIND_AUTOMATED_KEY = "automated_mockups";
export const FREE_CATALOG_KINDS = [
  CATALOG_KIND_BRANDED_KEY,
  CATALOG_KIND_LOCKER_KEY,
  CATALOG_KIND_WISHLIST_KEY,
  CATALOG_KIND_FREE_MOCKUPS_KEY,
  CATALOG_KIND_AUTOMATED_KEY,
];

export const NON_PREVIEWABLE_FORMATS = [".pdf", ".eps", ".ai"];

export const SWAGMAGIC_TOP_TARGET_URL =
  /(?:[a-zA-Z0-9-]+\.)?swagmagic\.com(\/(([a-zA-Z]{2}\/){2})?(stores\/|go\/book-a-call|swag-catalog\/))|^\/swag-catalog\//;
